import Layout from '../components/project/Layout'
import Contacts from '../components/contacts/Contacts'
import WorkspaceHeaderConsolidated from '../components/workspace/WorkspaceHeaderConsolidated'
import { useAuthStore } from '../stores/auth-store'
import { useUIStore } from '../stores/ui-store'
import { trpc } from '../lib/trpc'
import { useNavigate, useSearchParams } from 'react-router'
import { Loader2 } from 'lucide-react'

export default function ContactsPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { isAuthenticated } = useAuthStore()
  const { 
    openTaskCreationModal, 
    triggerNoteCreation,
    toggleFocusMode
  } = useUIStore()
  
  const { data: workspaces = [] } = trpc.workspace.list.useQuery()
  const activeWorkspace = workspaces[0]
  
  const { data: panels = [] } = trpc.panel.list.useQuery(
    { workspaceId: activeWorkspace?.id ?? '' },
    { 
      enabled: !!activeWorkspace?.id,
      staleTime: 60000,
    }
  )

  if (!isAuthenticated) {
    return null
  }

  if (!activeWorkspace) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-full">
          <div className="text-center">
            <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-blue-600" />
            <p className="text-gray-600">Loading contacts...</p>
          </div>
        </div>
      </Layout>
    )
  }

  const handleNavigate = (path: string) => {
    navigate(path)
  }

  const handleCreatePanel = (type: string) => {
    if (!activeWorkspace) return
    
    if (type === 'NOTE') {
      triggerNoteCreation()
      return
    }
    
    if (type === 'TASK') {
      openTaskCreationModal({})
      return
    }
  }

  const handleAction = (action: string) => {
    switch (action) {
      case 'logout':
        const authStore = useAuthStore.getState()
        authStore.logout()
        navigate('/login')
        break
        
      case 'focus-mode':
        toggleFocusMode()
        break
        
      default:
        break
    }
  }

  return (
    <Layout>
      <div className="flex flex-col min-h-full w-full bg-transparent">
        <WorkspaceHeaderConsolidated
          workspaceId={activeWorkspace.id}
          panels={panels}
          onNavigate={handleNavigate}
          onCreatePanel={handleCreatePanel}
          onAction={handleAction}
        />
        
        <div className="h-full flex-1">
          <Contacts workspaceId={activeWorkspace.id} selectedUserId={searchParams.get('user')} />
        </div>
      </div>
    </Layout>
  )
}